import { h } from "@/lib/dom";
import {
  openModal,
  field,
  textInput,
  button,
  swatchPicker,
  iconPicker,
  toast,
} from "@/components/ui";
import { subjectsService, pbErrorMessage } from "@/services";
import { defaultColor } from "@/lib/colors";
import type { Subject } from "@/types/models";

export function openSubjectForm(opts: {
  subject?: Subject;
  onSaved: () => void;
}): void {
  const editing = !!opts.subject;
  const titleInput = textInput({
    value: opts.subject?.title ?? "",
    placeholder: "z. B. Mathematik",
    required: true,
  });
  const colorPicker = swatchPicker(opts.subject?.color ?? defaultColor());
  const icons = iconPicker(opts.subject?.icon ?? "book");
  // Icon-Vorschläge kommen aus dem Fachnamen statt aus einem eigenen Suchfeld.
  icons.setQuery(titleInput.value);
  titleInput.addEventListener("input", () => icons.setQuery(titleInput.value));
  const errorBox = h("div", { class: "field-error" });
  const saveBtn = button({
    label: editing ? "Speichern" : "Anlegen",
    variant: "primary",
    onClick: save,
  });

  async function save() {
    const title = titleInput.value.trim();
    if (!title) {
      errorBox.textContent = "Bitte einen Titel eingeben.";
      return;
    }
    saveBtn.disabled = true;
    errorBox.textContent = "";
    try {
      const data = {
        title,
        color: colorPicker.getValue(),
        icon: icons.getValue(),
      };
      if (editing && opts.subject) {
        await subjectsService.update(opts.subject.id, data);
      } else {
        await subjectsService.create(data);
      }
      toast(editing ? "Fach aktualisiert." : "Fach angelegt.", "success");
      handle.close();
      opts.onSaved();
    } catch (err) {
      errorBox.textContent = pbErrorMessage(err);
      saveBtn.disabled = false;
    }
  }

  titleInput.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      void save();
    }
  });

  const handle = openModal({
    title: editing ? "Fach bearbeiten" : "Neues Fach",
    body: h(
      "div",
      null,
      field("Titel", titleInput),
      field("Farbe", colorPicker.el),
      field("Icon", icons.el),
      errorBox
    ),
    footer: h(
      "div",
      { class: "row" },
      button({ label: "Abbrechen", variant: "ghost", onClick: () => handle.close() }),
      saveBtn
    ),
  });

  setTimeout(() => titleInput.focus(), 50);
}
